module.exports = __webpack_public_path__ + "static/media/i-banking.2ad6cafb.svg";